import './ActivityItems.css';
import React from 'react';
import { compact } from 'lodash';
import { t } from '../../../../../locales/translate';
import { ItemDeleteActivity, ActivityModificationItem, getActivityModifications } from '../../../../../model/activity';
import { SortableList } from '../../../../../components/SortableList/SortableList';
import { useAsyncValue } from '../../../../../model/data';
import { GenericProduct, getProductName, Product } from '../../../../../model/product';
import { Icon } from '../../../../../components/Icon/Icon';
import { formatCurrency, formatDate } from '../../../../../util/util';
import { Event, getEventName } from '../../../../../model/event';
import { Seat } from '../../../../../model/ticket';

export function DeleteActivity({ activity }: { activity: ItemDeleteActivity }): JSX.Element | null {
  const [items, loading] = useAsyncValue<ActivityModificationItem[]>(() =>
    getActivityModifications({ id: activity.id })
  );

  if (loading) {
    return <Icon className="activity--loading" name="activity" loading />;
  }

  return (
    <SortableList
      items={items}
      columns={[
        {
          dataKey: 'productVariant',
          label: t.model.product.sku,
          cellRenderer: (row) => row.productVariant.sku,
        },
        {
          dataKey: 'product',
          label: t.general.name,
          cellRenderer: (row) => {
            switch (row.product.__typename) {
              case 'MerchProduct':
                return <div>{getProductName(row.product as Product)}</div>;
              case 'Event':
                return <EventName event={row.product as Event} seat={row.seat} />;
              case 'ShippingProduct':
                return <div>{(row.product as GenericProduct).name}</div>;
              default:
                return <div>{row.product.__typename}</div>;
            }
          },
        },
        {
          dataKey: 'seat',
          label: t.general.description,
          cellRenderer: (row) => row.productVariant.description,
        },
        {
          dataKey: 'total',
          label: t.model.price._name,
          cellRenderer: (row) => formatCurrency(row.total),
        },
      ]}
    />
  );
}

function EventName({ event, seat }: { event: Event; seat?: Seat }): JSX.Element {
  return (
    <div className="detail-block">
      <span>{getEventName(event)}</span>
      <span className="secondary-detail">
        {compact([
          formatDate(event?.happeningFrom),
          compact([event?.venue?.name, event?.venue?.address.city]).join(', '),
        ]).join(' - ')}
      </span>
      <span className="secondary-detail">
        {seat && compact([seat?.venueSection?.name, compact([seat?.row, seat?.name]).join(' / ')]).join(' - ')}
      </span>
    </div>
  );
}
